import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Formik } from "formik";
import addFundingSourceSchema from "./addFundingSource.schema";
import { successMessageToast } from "helpers/common";
import { FUNDING_SOURCE_LIST } from "config/paths";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import { useCreateFundingSourceMutation, useFundingSourceDetailsQuery, useUpdateFundingSourceMutation } from "store/services/fundingSource";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { RequiredFieldAstrick } from "components/Common/Common";

const AddFundingSource = () => {

  const { id: fundingSourceId } = useParams();
  const editMode = !!fundingSourceId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    name: "",
    // contact_first_name: "",
    // contact_last_name: "",
    // contact_title: "",
    // email: "",
    // phone_number: "",
    description: "",
    status: "active"
  });

  const [createFundingSource, { isLoading: createFundingSourceLoading }] = useCreateFundingSourceMutation();
  const [updateFundingSource, { isLoading: updateFundingSourceLoading }] = useUpdateFundingSourceMutation();
  const { data: fundingSourceDetails, isLoading } = fundingSourceId ? useFundingSourceDetailsQuery(fundingSourceId) : {};

  const handleSubmit = async (payload) => {

    try {

      const result = editMode ? await updateFundingSource({ data: payload, fundingSourceId }) : await createFundingSource(payload);
      if (result?.error) return console.error("Error Create Funding Source", result.error);

      successMessageToast(result?.data?.message);
      navigate(FUNDING_SOURCE_LIST);

    } catch (err) {
      console.error("Error Funding Source", err);
    }
  };

  const handleCancelClick = () => {

    navigate(FUNDING_SOURCE_LIST);
  };

  useEffect(() => {

    if (!fundingSourceId) return;

    setInitialValues({
      ...initialValues,
      name: fundingSourceDetails?.name || "",
      // contact_first_name: fundingSourceDetails?.contact_first_name || "",
      // contact_last_name: fundingSourceDetails?.contact_last_name || "",
      // contact_title: fundingSourceDetails?.contact_title || "",
      // email: fundingSourceDetails?.email || "",
      // phone_number: fundingSourceDetails?.phone_number || "",
      description: fundingSourceDetails?.description || "",
      status: fundingSourceDetails?.status || ""
    });

  }, [fundingSourceDetails]);
  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to="/manage-private-clients/funding-sources/"
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Funding Source" : "Add New Funding Source"}</h6>
              </div>
            </Col>
            {
              isLoading ? <LoadingIndicator /> :
                <Col lg="12" className="my-2">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={addFundingSourceSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Source Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="name"
                                placeholder="Source Name"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            {/* <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Email
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="email"
                                placeholder="e.g Smith"
                                className={`${styles.formControl} form-control`}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Phone
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="phone_number"
                                placeholder="e.g 123456789"
                                className={`${styles.formControl} form-control`}
                                maxLength={25}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Contact Person Title
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="contact_title"
                                placeholder="e.g Mr."
                                className={`${styles.formControl} form-control`}
                                maxLength={10}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Contact Person Last Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="contact_last_name"
                                placeholder="e.g John"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Contact Person First Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="contact_first_name"
                                placeholder="e.g John"
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col> */}
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Status
                                <RequiredFieldAstrick />
                              </label>
                              <AppSelectField
                                name="status"
                                placeholder={"Please Select"}
                                className={`${styles.formControl} form-control`}
                                options={[
                                  {
                                    value: "active",
                                    label: "Active",
                                  },
                                  {
                                    value: "archived",
                                    label: "Archived",
                                  }
                                ]}
                              />
                            </Col>
                            <Col md="12" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Description
                              </label>
                              <AppInputField
                                type="textarea"
                                fieldType="textarea"
                                name="description"
                                rows={5}
                                className={`${styles.formControl} form-control`}
                                maxLength={500}
                              />
                            </Col>
                          </Row>
                        </div>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button disabled={createFundingSourceLoading || updateFundingSourceLoading} type="submit" className="d-flex align-items-center justify-content-center commonBtn">
                                {createFundingSourceLoading || updateFundingSourceLoading ? <LoadingIndicator inline /> : "Save"}

                              </Button>
                              <Button
                                type="button"
                                className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                onClick={handleCancelClick}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddFundingSource;
